import { render } from "./DemoAccountTip.vue?vue&type=template&id=68e4d06c&scoped=true&ts=true"
import script from "./DemoAccountTip.vue?vue&type=script&lang=ts"
export * from "./DemoAccountTip.vue?vue&type=script&lang=ts"

import "./DemoAccountTip.vue?vue&type=style&index=0&id=68e4d06c&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e4d06c"]])

export default __exports__